import React from 'react';
import withDrawingContainer, { withDrawingContainerProps } from './withDrawingContainer';
import { Group, Rect, Text, Image } from 'react-konva';
import { AnnotationUpdateDetails, DrawingType } from '../constants';
import { useModalHandlers } from 'components/modal';
import UpdateAnnotationText from 'components/well/components/UpdateAnnotationText';
import { RMSvgIconImage } from 'components/customComponents/CommonComponents/RMSvgIcon';

interface Props extends withDrawingContainerProps {
  zoomScale?: number;
  backgroundColor: string;
  size: number;
  fontFamily: string;
  fontStyle: string;
  textDecoration: string;
  textColor: string;
  text: string;
}
const annotationIcon = RMSvgIconImage({ name: 'AnnotationCanvasIcon' });
const AnnotationDrawing = (props: Props) => {
  const {
    id,
    rectRef,
    width,
    height,
    isSelected,
    zoomScale,
    backgroundColor,
    size,
    fontFamily,
    fontStyle,
    textDecoration,
    textColor,
    text,
    saveAndUpdateDrawing,
    expanded,
  } = props;
  const { showModal, hideModal } = useModalHandlers();
  const scaledWidth = width / zoomScale;
  const scaledHeight = height / zoomScale;
  const textWidthRatio = (width - 5) / zoomScale;
  const textHeightRatio = (height - 5) / zoomScale;
  const fontSize = size / zoomScale;

  const updateAnnotationText = (text) => {
    saveAndUpdateDrawing(id, DrawingType.Annotation, { text });
  };

  const onDoubleClickAnnotation = () => {
    showModal({
      body: (
        <UpdateAnnotationText
          text={text}
          hideModal={hideModal}
          updateAnnotationText={updateAnnotationText}
        />
      ),
      showButtons: false,
    });
  };
  return (
    <>
      {expanded ? (
        <Group id={`annotationdrawing-group-${id}`} onDblClick={onDoubleClickAnnotation}>
          <Rect
            id={`annotationdrawing-rect-${id}`}
            ref={rectRef}
            width={scaledWidth}
            height={scaledHeight}
            strokeWidth={3 / zoomScale}
            stroke="#FFFF28"
            fill={`rgb(${backgroundColor})`}
            shadowBlur={isSelected ? 10 : 0}
            shadowColor={isSelected ? 'black' : ''}
            shadowOpacity={isSelected ? 5 : 0}
            shadowEnabled={isSelected ? true : false}
          />
          <Text
            id={`annotationdrawing-text-${id}`}
            x={5 / zoomScale}
            y={5 / zoomScale}
            width={scaledWidth < textWidthRatio ? scaledWidth : textWidthRatio}
            height={scaledHeight < textHeightRatio ? scaledHeight : textHeightRatio}
            fontSize={fontSize}
            fontFamily={fontFamily}
            fontStyle={fontStyle}
            textDecoration={textDecoration}
            fill={`rgb(${textColor})`}
            textAnchor="middle"
            text={text}
          />
        </Group>
      ) : (
        <Group id={`collalpsed-annotationdrawing-group-${id}`}>
          <Rect
            id={`collapsed-annotationdrawing-rect-${id}`}
            ref={rectRef}
            width={60}
            height={60}
            strokeWidth={3 / zoomScale}
            stroke="#7FB4F9"
            fill={'#FFFFFF'}
            shadowBlur={isSelected ? 10 : 0}
            shadowColor={isSelected ? 'black' : ''}
            shadowOpacity={isSelected ? 5 : 0}
            shadowEnabled={isSelected ? true : false}
            cornerRadius={2}
          />
          <Image
            id={`collapsed-annotationdrawing-image-${id}`}
            image={annotationIcon}
            x={15}
            y={15}
            width={30}
            height={30}
          />
        </Group>
      )}
    </>
  );
};

const moveActionPreProcessor = (
  props: Props,
  x: number,
  y: number,
): AnnotationUpdateDetails => {
  const [transformedX, transformedY] = props.tpObject.FromCanvasToDb(x, y);
  return { x, y, dbX: transformedX, dbY: transformedY };
};

const transformActionPreProcessor = (
  props: Props,
  width: number,
  height: number,
): AnnotationUpdateDetails => {
  return { width, height };
};
export default withDrawingContainer(
  AnnotationDrawing,
  DrawingType.Annotation,
  moveActionPreProcessor,
  transformActionPreProcessor,
);
